import * as React from 'react';
import { useSpring, animated } from 'react-spring';

import AnimatedBlock, { DISPLACEMENT } from '../AnimatedBlock';

interface Props {
  stiffness: number;
  damping: number;
  mass: number;
  triggeredAt: number | null;
  direction: 'left' | 'right';
}

function SpringAnimation({ stiffness, damping, direction }: Props) {
  const style = useSpring({
    transform: `translateX(${
      direction === 'left' ? 0 : DISPLACEMENT
    }px)`,
    config: {
      tension: stiffness,
      friction: damping,
    },
  });

  return <AnimatedBlock blockAs={animated.div} style={style} />;
}

export default SpringAnimation;
